module.exports = __webpack_public_path__ + "media/img/Landing_Page/homepage-banner-03-4c06b7880db4ba6b1a5b8ec1fb8bf61d.jpg";